import { MoneyPh } from '~shared/ui/money-ph';

import { Typography } from '@breezeventures/ui-kit/typography';

import type { SummaryTableData } from '../model/summary-table-data';

type DetailRowProps = {
  label: string;
  children: React.ReactNode;
};

const DetailRow = ({ label, children }: DetailRowProps) => (
  <li className="grid grid-cols-2 items-start gap-4 px-4 py-4">
    <Typography.Text size="m" color="secondary" tag="span">
      {label}
    </Typography.Text>
    <Typography.Text size="m" tag="span" className="min-w-0 text-left">
      {children}
    </Typography.Text>
  </li>
);

type Props = {
  row: SummaryTableData;
};

export const SummaryRowDetails = ({ row }: Props) => (
  <ul
    className={`
      m-0 list-none divide-y divide-separator overflow-hidden rounded-xl border
      border-separator p-0
    `}
  >
    <DetailRow label="Business">{row.merchantName}</DetailRow>

    {row.posName && <DetailRow label="Store">{row.posName}</DetailRow>}

    <DetailRow label="Number of loans">{row.loansCount}</DetailRow>

    <DetailRow label="Loans amount">
      <MoneyPh value={row.loansAmount} />
    </DetailRow>

    <DetailRow label="Sales amount">
      <MoneyPh value={row.salesAmount} />
    </DetailRow>
  </ul>
);
